import { biometryApi } from '~/app/modules/biometry/utils/api.const';
import { WEB_ROUTES } from '~/app/shared/utils/web-config';
import {
  BIOMETRY_STATUS,
  BiometryRedirectRoutes,
  queryParamKey,
  biometryStatusKey,
  CreateBiometryRequestTrigger,
} from '~/app/modules/biometry/utils/biometry.consts';

export class BiometryService {
  ctx;

  #redirectQueryParam = '';

  #biometryStatus = '';

  timerId = null;

  timeoutMs = 10000;

  constructor(ctx) {
    this.ctx = ctx;
  }

  set redirectQueryParam(value) {
    this.#redirectQueryParam = value;
    localStorage.setItem(queryParamKey, value);
  }

  get redirectQueryParam() {
    return this.#redirectQueryParam || localStorage.getItem(queryParamKey);
  }

  set biometryStatus(value) {
    this.#biometryStatus = value;
    localStorage.setItem(biometryStatusKey, value);
  }

  get biometryStatus() {
    return this.#biometryStatus || localStorage.getItem(biometryStatusKey);
  }

  specificRedirectUrl(status = null) {
    const biometrySpecificRoutes = BiometryRedirectRoutes[this.redirectQueryParam];

    return biometrySpecificRoutes[status || this.biometryStatus];
  }

  createBiometry() {
    const payload = {
      request_trigger:
        CreateBiometryRequestTrigger[this.redirectQueryParam] ||
        CreateBiometryRequestTrigger.profile,
    };

    return this.ctx.$api.dispatch(biometryApi.createBiometry, payload);
  }

  /** @type {Promise<(BiometryStatusActive|BiometryStatusNotActive)>} */
  fetchBiometryStatus() {
    return this.ctx.$api.dispatch(biometryApi.getBiometryStatus);
  }

  /** @type {Promise<BiometryConfig>} */
  fetchBiometryConfig() {
    return this.ctx.$api.dispatch(biometryApi.getBiometryConfig);
  }

  clear() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    localStorage.removeItem(queryParamKey);
    localStorage.removeItem(biometryStatusKey);
  }

  async pollStatus() {
    const { data: biometry } = await this.fetchBiometryStatus();

    if (!biometry.status) {
      throw new Error('Biometry status is not received.');
    }

    this.biometryStatus = biometry.status;

    if (biometry.status === BIOMETRY_STATUS.DECLINED) {
      this.ctx.redirect(this.ctx.app.localePath(WEB_ROUTES.BIOMETRY_REJECTED));
    }

    if ([BIOMETRY_STATUS.PENDING, BIOMETRY_STATUS.FAILED].includes(biometry.status)) {
      this.timerId = setTimeout(() => this.pollStatus(), this.timeoutMs);
      return;
    }

    const url = this.specificRedirectUrl(biometry.status);
    this.ctx.redirect(this.ctx.app.localePath(url));
  }
}
